import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _50c2dd9c = () => interopDefault(import('../pages/accept-collection.vue' /* webpackChunkName: "pages/accept-collection" */))
const _4530798f = () => interopDefault(import('../pages/accept-collection-actual.vue' /* webpackChunkName: "pages/accept-collection-actual" */))
const _3a3edb56 = () => interopDefault(import('../pages/accept-collection-magazine.vue' /* webpackChunkName: "pages/accept-collection-magazine" */))
const _1eb04fb3 = () => interopDefault(import('../pages/accept-collection-simple.vue' /* webpackChunkName: "pages/accept-collection-simple" */))
const _18fab548 = () => interopDefault(import('../pages/authority.vue' /* webpackChunkName: "pages/authority" */))
const _44bcb6df = () => interopDefault(import('../pages/authority/index.vue' /* webpackChunkName: "pages/authority/index" */))
const _0f78e507 = () => interopDefault(import('../pages/authority/_id.vue' /* webpackChunkName: "pages/authority/_id" */))
const _b2dcee6e = () => interopDefault(import('../pages/batch-menu.vue' /* webpackChunkName: "pages/batch-menu" */))
const _3e92622a = () => interopDefault(import('../pages/batch-menu/bibliography-register/index.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/index" */))
const _2e1047e2 = () => interopDefault(import('../pages/batch-menu/collection-management/index.vue' /* webpackChunkName: "pages/batch-menu/collection-management/index" */))
const _3dc6ad19 = () => interopDefault(import('../pages/batch-menu/inventory/index.vue' /* webpackChunkName: "pages/batch-menu/inventory/index" */))
const _4b704c8c = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/index.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/index" */))
const _32293f1b = () => interopDefault(import('../pages/batch-menu/mail-send/index.vue' /* webpackChunkName: "pages/batch-menu/mail-send/index" */))
const _7122cbe0 = () => interopDefault(import('../pages/batch-menu/order-accept/index.vue' /* webpackChunkName: "pages/batch-menu/order-accept/index" */))
const _a08dd5aa = () => interopDefault(import('../pages/batch-menu/reminder/index.vue' /* webpackChunkName: "pages/batch-menu/reminder/index" */))
const _acec1a4e = () => interopDefault(import('../pages/batch-menu/school-statistics/index.vue' /* webpackChunkName: "pages/batch-menu/school-statistics/index" */))
const _3e698ac3 = () => interopDefault(import('../pages/batch-menu/selection-book/index.vue' /* webpackChunkName: "pages/batch-menu/selection-book/index" */))
const _c963e5c8 = () => interopDefault(import('../pages/batch-menu/statistics/index.vue' /* webpackChunkName: "pages/batch-menu/statistics/index" */))
const _9f31a2fc = () => interopDefault(import('../pages/batch-menu/user-management/index.vue' /* webpackChunkName: "pages/batch-menu/user-management/index" */))
const _51d22378 = () => interopDefault(import('../pages/batch-menu/bibliography-register/av-library-marc-register.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/av-library-marc-register" */))
const _17ee0d4f = () => interopDefault(import('../pages/batch-menu/bibliography-register/bibliography-collection-export.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/bibliography-collection-export" */))
const _ebb9e680 = () => interopDefault(import('../pages/batch-menu/bibliography-register/bibliography-collection-import.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/bibliography-collection-import" */))
const _5e136cfe = () => interopDefault(import('../pages/batch-menu/bibliography-register/dc-ndl-register.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/dc-ndl-register" */))
const _213c0030 = () => interopDefault(import('../pages/batch-menu/bibliography-register/nhk-marc-register.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/nhk-marc-register" */))
const _5c1e886c = () => interopDefault(import('../pages/batch-menu/bibliography-register/nrc-marc-catalog-register.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/nrc-marc-catalog-register" */))
const _65dd036a = () => interopDefault(import('../pages/batch-menu/bibliography-register/nrc-marc-content-register.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/nrc-marc-content-register" */))
const _9ced3876 = () => interopDefault(import('../pages/batch-menu/bibliography-register/order-marc-register.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/order-marc-register" */))
const _12d83f1e = () => interopDefault(import('../pages/batch-menu/bibliography-register/oricon-marc-register.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/oricon-marc-register" */))
const _27a4d4d1 = () => interopDefault(import('../pages/batch-menu/bibliography-register/tohan-content-detail-register.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/tohan-content-detail-register" */))
const _05dd16ae = () => interopDefault(import('../pages/batch-menu/bibliography-register/tohan-mark-register.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/tohan-mark-register" */))
const _2785f668 = () => interopDefault(import('../pages/batch-menu/bibliography-register/trc-authority-register.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/trc-authority-register" */))
const _3804c79c = () => interopDefault(import('../pages/batch-menu/bibliography-register/trc-authority-update.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/trc-authority-update" */))
const _167182da = () => interopDefault(import('../pages/batch-menu/bibliography-register/trc-books-and-av-register.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/trc-books-and-av-register" */))
const _c0ecc88e = () => interopDefault(import('../pages/batch-menu/bibliography-register/trc-books-and-av-update.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/trc-books-and-av-update" */))
const _610c55fc = () => interopDefault(import('../pages/batch-menu/bibliography-register/trc-content-detail-register.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/trc-content-detail-register" */))
const _f4610d3c = () => interopDefault(import('../pages/batch-menu/bibliography-register/trc-content-detail-update.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/trc-content-detail-update" */))
const _75c7c852 = () => interopDefault(import('../pages/batch-menu/bibliography-register/trc-contents-data-register.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/trc-contents-data-register" */))
const _8b60ed90 = () => interopDefault(import('../pages/batch-menu/bibliography-register/trc-contents-data-update.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/trc-contents-data-update" */))
const _4ff345f4 = () => interopDefault(import('../pages/batch-menu/bibliography-register/trc-new-book-automatic-order.vue' /* webpackChunkName: "pages/batch-menu/bibliography-register/trc-new-book-automatic-order" */))
const _4fd6e730 = () => interopDefault(import('../pages/batch-menu/collection-management/another-facility-in-transit-collection-list.vue' /* webpackChunkName: "pages/batch-menu/collection-management/another-facility-in-transit-collection-list" */))
const _3ed59272 = () => interopDefault(import('../pages/batch-menu/collection-management/bibliography-and-collection-bulk-removal.vue' /* webpackChunkName: "pages/batch-menu/collection-management/bibliography-and-collection-bulk-removal" */))
const _7dee7479 = () => interopDefault(import('../pages/batch-menu/collection-management/bibliography-bulk-removal.vue' /* webpackChunkName: "pages/batch-menu/collection-management/bibliography-bulk-removal" */))
const _69c89ece = () => interopDefault(import('../pages/batch-menu/collection-management/bibliography-collection-info-output.vue' /* webpackChunkName: "pages/batch-menu/collection-management/bibliography-collection-info-output" */))
const _1a136dfd = () => interopDefault(import('../pages/batch-menu/collection-management/collection-bulk-removal.vue' /* webpackChunkName: "pages/batch-menu/collection-management/collection-bulk-removal" */))
const _4b61c414 = () => interopDefault(import('../pages/batch-menu/collection-management/invalid-collection-list.vue' /* webpackChunkName: "pages/batch-menu/collection-management/invalid-collection-list" */))
const _1b28d297 = () => interopDefault(import('../pages/batch-menu/collection-management/list-by-collection-status.vue' /* webpackChunkName: "pages/batch-menu/collection-management/list-by-collection-status" */))
const _77845d89 = () => interopDefault(import('../pages/batch-menu/collection-management/removal-collection-list.vue' /* webpackChunkName: "pages/batch-menu/collection-management/removal-collection-list" */))
const _78288ae2 = () => interopDefault(import('../pages/batch-menu/collection-management/reserve-in-transit-collection-list.vue' /* webpackChunkName: "pages/batch-menu/collection-management/reserve-in-transit-collection-list" */))
const _355f4044 = () => interopDefault(import('../pages/batch-menu/collection-management/transfer-collection-list.vue' /* webpackChunkName: "pages/batch-menu/collection-management/transfer-collection-list" */))
const _60cbc42c = () => interopDefault(import('../pages/batch-menu/collection-management/unknown-collection-statistics.vue' /* webpackChunkName: "pages/batch-menu/collection-management/unknown-collection-statistics" */))
const _377f7d36 = () => interopDefault(import('../pages/batch-menu/inventory/list-inventory.vue' /* webpackChunkName: "pages/batch-menu/inventory/list-inventory" */))
const _0808fb3c = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/borrowed-collection-list.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/borrowed-collection-list" */))
const _6232e0e8 = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/collection-list-by-lend-books-count.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/collection-list-by-lend-books-count" */))
const _168ac68c = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/forced-return.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/forced-return" */))
const _20258b57 = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/lend-collection-list.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/lend-collection-list" */))
const _af972c3c = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/lend-db-update.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/lend-db-update" */))
const _2409c260 = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/lend-info-extraction.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/lend-info-extraction" */))
const _d1ef8330 = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/on-shelf-reserve-list.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/on-shelf-reserve-list" */))
const _3418bb30 = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/reserve-cancel-list.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/reserve-cancel-list" */))
const _40d85978 = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/reserve-collection-list.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/reserve-collection-list" */))
const _59c24f7d = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/reserve-contact-mail.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/reserve-contact-mail" */))
const _59ba4c56 = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/reserve-contact-postcard-date.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/reserve-contact-postcard-date" */))
const _58657f72 = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/reserve-contact-postcard-user.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/reserve-contact-postcard-user" */))
const _604562dd = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/reserve-return-waiting-collection-forwarding-candidate-list.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/reserve-return-waiting-collection-forwarding-candidate-list" */))
const _36cb4949 = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/reserve-return-waiting-collection-list.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/reserve-return-waiting-collection-list" */))
const _29cdf5a5 = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/reserve-standing-collection-list.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/reserve-standing-collection-list" */))
const _9f4d5812 = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/reserve-user-list.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/reserve-user-list" */))
const _1eef1463 = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/return-db-update.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/return-db-update" */))
const _7c922491 = () => interopDefault(import('../pages/batch-menu/lend-return-reserve/return-info-extraction.vue' /* webpackChunkName: "pages/batch-menu/lend-return-reserve/return-info-extraction" */))
const _5bdfd5a7 = () => interopDefault(import('../pages/batch-menu/mail-send/mail-send.vue' /* webpackChunkName: "pages/batch-menu/mail-send/mail-send" */))
const _6ed1ce48 = () => interopDefault(import('../pages/batch-menu/order-accept/accept-ledger.vue' /* webpackChunkName: "pages/batch-menu/order-accept/accept-ledger" */))
const _2f088c6c = () => interopDefault(import('../pages/batch-menu/order-accept/delivery-and-situation-list.vue' /* webpackChunkName: "pages/batch-menu/order-accept/delivery-and-situation-list" */))
const _c34d9230 = () => interopDefault(import('../pages/batch-menu/order-accept/long-over-due-collection-purchase-candidate-list.vue' /* webpackChunkName: "pages/batch-menu/order-accept/long-over-due-collection-purchase-candidate-list" */))
const _5b5843dc = () => interopDefault(import('../pages/batch-menu/order-accept/missing-number-collection-list.vue' /* webpackChunkName: "pages/batch-menu/order-accept/missing-number-collection-list" */))
const _ebdafd04 = () => interopDefault(import('../pages/batch-menu/order-accept/new-breaking-news.vue' /* webpackChunkName: "pages/batch-menu/order-accept/new-breaking-news" */))
const _262a081f = () => interopDefault(import('../pages/batch-menu/order-accept/order-list.vue' /* webpackChunkName: "pages/batch-menu/order-accept/order-list" */))
const _336b35eb = () => interopDefault(import('../pages/batch-menu/order-accept/selection-candidate-list.vue' /* webpackChunkName: "pages/batch-menu/order-accept/selection-candidate-list" */))
const _f472aad0 = () => interopDefault(import('../pages/batch-menu/order-accept/tohan-books-order-data-create.vue' /* webpackChunkName: "pages/batch-menu/order-accept/tohan-books-order-data-create" */))
const _15be2230 = () => interopDefault(import('../pages/batch-menu/order-accept/trc-accept-marc-register.vue' /* webpackChunkName: "pages/batch-menu/order-accept/trc-accept-marc-register" */))
const _643b2503 = () => interopDefault(import('../pages/batch-menu/order-accept/trc-books-order-data-create.vue' /* webpackChunkName: "pages/batch-menu/order-accept/trc-books-order-data-create" */))
const _dab20fb2 = () => interopDefault(import('../pages/batch-menu/order-accept/undelivered-and-situation-list.vue' /* webpackChunkName: "pages/batch-menu/order-accept/undelivered-and-situation-list" */))
const _7d1dd97a = () => interopDefault(import('../pages/batch-menu/reminder/reminder-letter.vue' /* webpackChunkName: "pages/batch-menu/reminder/reminder-letter" */))
const _72d2a8f2 = () => interopDefault(import('../pages/batch-menu/reminder/reminder-list.vue' /* webpackChunkName: "pages/batch-menu/reminder/reminder-list" */))
const _2200c98b = () => interopDefault(import('../pages/batch-menu/reminder/reminder-mail.vue' /* webpackChunkName: "pages/batch-menu/reminder/reminder-mail" */))
const _6f4db5f8 = () => interopDefault(import('../pages/batch-menu/reminder/reminder-postcard.vue' /* webpackChunkName: "pages/batch-menu/reminder/reminder-postcard" */))
const _e8831eb2 = () => interopDefault(import('../pages/batch-menu/school-statistics/advancement.vue' /* webpackChunkName: "pages/batch-menu/school-statistics/advancement" */))
const _25241ada = () => interopDefault(import('../pages/batch-menu/school-statistics/best-reader.vue' /* webpackChunkName: "pages/batch-menu/school-statistics/best-reader" */))
const _616129b8 = () => interopDefault(import('../pages/batch-menu/school-statistics/lend.vue' /* webpackChunkName: "pages/batch-menu/school-statistics/lend" */))
const _33f83058 = () => interopDefault(import('../pages/batch-menu/school-statistics/lend-collection-list.vue' /* webpackChunkName: "pages/batch-menu/school-statistics/lend-collection-list" */))
const _53138ee1 = () => interopDefault(import('../pages/batch-menu/school-statistics/new-student-registration.vue' /* webpackChunkName: "pages/batch-menu/school-statistics/new-student-registration" */))
const _72ba90e7 = () => interopDefault(import('../pages/batch-menu/school-statistics/user-list.vue' /* webpackChunkName: "pages/batch-menu/school-statistics/user-list" */))
const _5f8701cf = () => interopDefault(import('../pages/batch-menu/selection-book/selection-book-and-bibliography-list.vue' /* webpackChunkName: "pages/batch-menu/selection-book/selection-book-and-bibliography-list" */))
const _0cca4c07 = () => interopDefault(import('../pages/batch-menu/selection-book/selection-book-and-order-list.vue' /* webpackChunkName: "pages/batch-menu/selection-book/selection-book-and-order-list" */))
const _fa769f36 = () => interopDefault(import('../pages/batch-menu/selection-book/selection-book-and-order-situation.vue' /* webpackChunkName: "pages/batch-menu/selection-book/selection-book-and-order-situation" */))
const _930fe2d4 = () => interopDefault(import('../pages/batch-menu/statistics/best-reader.vue' /* webpackChunkName: "pages/batch-menu/statistics/best-reader" */))
const _1164e99a = () => interopDefault(import('../pages/batch-menu/statistics/collection-and-removal-statistics.vue' /* webpackChunkName: "pages/batch-menu/statistics/collection-and-removal-statistics" */))
const _168cc0fe = () => interopDefault(import('../pages/batch-menu/statistics/daily-statistics-output.vue' /* webpackChunkName: "pages/batch-menu/statistics/daily-statistics-output" */))
const _2f5f3b15 = () => interopDefault(import('../pages/batch-menu/statistics/lend.vue' /* webpackChunkName: "pages/batch-menu/statistics/lend" */))
const _71284416 = () => interopDefault(import('../pages/batch-menu/statistics/monthly-statistics-output.vue' /* webpackChunkName: "pages/batch-menu/statistics/monthly-statistics-output" */))
const _5ee57033 = () => interopDefault(import('../pages/batch-menu/statistics/pack-lend-statistics.vue' /* webpackChunkName: "pages/batch-menu/statistics/pack-lend-statistics" */))
const _7163fa8d = () => interopDefault(import('../pages/batch-menu/statistics/public-library-questionnaire-statistics.vue' /* webpackChunkName: "pages/batch-menu/statistics/public-library-questionnaire-statistics" */))
const _4b363768 = () => interopDefault(import('../pages/batch-menu/statistics/reference-and-copy-and-entertainment-statistics.vue' /* webpackChunkName: "pages/batch-menu/statistics/reference-and-copy-and-entertainment-statistics" */))
const _041f0b62 = () => interopDefault(import('../pages/batch-menu/statistics/registrant-statistics.vue' /* webpackChunkName: "pages/batch-menu/statistics/registrant-statistics" */))
const _93976d0a = () => interopDefault(import('../pages/batch-menu/statistics/reserve-best.vue' /* webpackChunkName: "pages/batch-menu/statistics/reserve-best" */))
const _6ad4b1fa = () => interopDefault(import('../pages/batch-menu/statistics/reserve-statistics.vue' /* webpackChunkName: "pages/batch-menu/statistics/reserve-statistics" */))
const _043017ac = () => interopDefault(import('../pages/batch-menu/statistics/return-statistics.vue' /* webpackChunkName: "pages/batch-menu/statistics/return-statistics" */))
const _23bbcb9a = () => interopDefault(import('../pages/batch-menu/statistics/select-shelf-lend-statistics.vue' /* webpackChunkName: "pages/batch-menu/statistics/select-shelf-lend-statistics" */))
const _7e31630e = () => interopDefault(import('../pages/batch-menu/statistics/yearly-statistics-output.vue' /* webpackChunkName: "pages/batch-menu/statistics/yearly-statistics-output" */))
const _711a0466 = () => interopDefault(import('../pages/batch-menu/user-management/basic-residents-data-register.vue' /* webpackChunkName: "pages/batch-menu/user-management/basic-residents-data-register" */))
const _1cc3eb6e = () => interopDefault(import('../pages/batch-menu/user-management/data-shortage-user-list.vue' /* webpackChunkName: "pages/batch-menu/user-management/data-shortage-user-list" */))
const _f3192930 = () => interopDefault(import('../pages/batch-menu/user-management/expired-user-list.vue' /* webpackChunkName: "pages/batch-menu/user-management/expired-user-list" */))
const _74591a64 = () => interopDefault(import('../pages/batch-menu/user-management/user-data-register.vue' /* webpackChunkName: "pages/batch-menu/user-management/user-data-register" */))
const _0bcfd010 = () => interopDefault(import('../pages/batch-menu/user-management/user-list.vue' /* webpackChunkName: "pages/batch-menu/user-management/user-list" */))
const _73f0426a = () => interopDefault(import('../pages/batch-menu/user-management/user-removal.vue' /* webpackChunkName: "pages/batch-menu/user-management/user-removal" */))
const _fb692c92 = () => interopDefault(import('../pages/bibliographies.vue' /* webpackChunkName: "pages/bibliographies" */))
const _9e8cea0c = () => interopDefault(import('../pages/bibliographies/index.vue' /* webpackChunkName: "pages/bibliographies/index" */))
const _0a42007c = () => interopDefault(import('../pages/bibliographies/detail-real.vue' /* webpackChunkName: "pages/bibliographies/detail-real" */))
const _18c80c24 = () => interopDefault(import('../pages/bibliographies/detail-set.vue' /* webpackChunkName: "pages/bibliographies/detail-set" */))
const _1f0fddb2 = () => interopDefault(import('../pages/bibliographies/index.type.ts' /* webpackChunkName: "pages/bibliographies/index.type" */))
const _a9af2bec = () => interopDefault(import('../pages/bibliographies/search-result.vue' /* webpackChunkName: "pages/bibliographies/search-result" */))
const _28673b80 = () => interopDefault(import('../pages/bibliographies/search-result-authority.vue' /* webpackChunkName: "pages/bibliographies/search-result-authority" */))
const _3edb39b6 = () => interopDefault(import('../pages/bibliographies/search-result-content.vue' /* webpackChunkName: "pages/bibliographies/search-result-content" */))
const _d6f8e1cc = () => interopDefault(import('../pages/bibliography-collection-bulk-edit.vue' /* webpackChunkName: "pages/bibliography-collection-bulk-edit" */))
const _057f552d = () => interopDefault(import('../pages/borrowing-history.vue' /* webpackChunkName: "pages/borrowing-history" */))
const _0fd38b27 = () => interopDefault(import('../pages/collection-browse-inside.vue' /* webpackChunkName: "pages/collection-browse-inside" */))
const _4f8f0ac6 = () => interopDefault(import('../pages/collection-list.vue' /* webpackChunkName: "pages/collection-list" */))
const _247de4c9 = () => interopDefault(import('../pages/collection-list/index.vue' /* webpackChunkName: "pages/collection-list/index" */))
const _1aa08571 = () => interopDefault(import('../pages/collection-list/_id.vue' /* webpackChunkName: "pages/collection-list/_id" */))
const _670275fb = () => interopDefault(import('../pages/forward-request-answer.vue' /* webpackChunkName: "pages/forward-request-answer" */))
const _3c9acc2f = () => interopDefault(import('../pages/forward-request-status.vue' /* webpackChunkName: "pages/forward-request-status" */))
const _63d9b956 = () => interopDefault(import('../pages/ic-tag-encode.vue' /* webpackChunkName: "pages/ic-tag-encode" */))
const _e4497daa = () => interopDefault(import('../pages/inspection.vue' /* webpackChunkName: "pages/inspection" */))
const _2dc20924 = () => interopDefault(import('../pages/inspection/index.vue' /* webpackChunkName: "pages/inspection/index" */))
const _5a0a6627 = () => interopDefault(import('../pages/inspection/input-offline/_id.vue' /* webpackChunkName: "pages/inspection/input-offline/_id" */))
const _fb94cdde = () => interopDefault(import('../pages/inspection/input/_id.vue' /* webpackChunkName: "pages/inspection/input/_id" */))
const _3679a5c0 = () => interopDefault(import('../pages/inspection/output/_id.vue' /* webpackChunkName: "pages/inspection/output/_id" */))
const _3abc767c = () => interopDefault(import('../pages/inspection-bulk-update.vue' /* webpackChunkName: "pages/inspection-bulk-update" */))
const _012b5b66 = () => interopDefault(import('../pages/jobs.vue' /* webpackChunkName: "pages/jobs" */))
const _5c55bb34 = () => interopDefault(import('../pages/lend.vue' /* webpackChunkName: "pages/lend" */))
const _c3d5fea6 = () => interopDefault(import('../pages/lend-history.vue' /* webpackChunkName: "pages/lend-history" */))
const _113cb302 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _4241945c = () => interopDefault(import('../pages/operation-management-menu.vue' /* webpackChunkName: "pages/operation-management-menu" */))
const _03673442 = () => interopDefault(import('../pages/operation-management-menu/index.vue' /* webpackChunkName: "pages/operation-management-menu/index" */))
const _e2ec0e50 = () => interopDefault(import('../pages/operation-management-menu/budget-management.vue' /* webpackChunkName: "pages/operation-management-menu/budget-management" */))
const _fbe1ec58 = () => interopDefault(import('../pages/operation-management-menu/closing-day-setting.vue' /* webpackChunkName: "pages/operation-management-menu/closing-day-setting" */))
const _d3ed881a = () => interopDefault(import('../pages/operation-management-menu/code-setting.vue' /* webpackChunkName: "pages/operation-management-menu/code-setting" */))
const _45ed5ce4 = () => interopDefault(import('../pages/operation-management-menu/delete-by-series.vue' /* webpackChunkName: "pages/operation-management-menu/delete-by-series" */))
const _ed1a4f3e = () => interopDefault(import('../pages/operation-management-menu/lend-books-count-confirmation.vue' /* webpackChunkName: "pages/operation-management-menu/lend-books-count-confirmation" */))
const _1ab72cae = () => interopDefault(import('../pages/operation-management-menu/login-user-management.vue' /* webpackChunkName: "pages/operation-management-menu/login-user-management" */))
const _48e4c31f = () => interopDefault(import('../pages/operation-management-menu/new-arrival-magazine-mail-setting.vue' /* webpackChunkName: "pages/operation-management-menu/new-arrival-magazine-mail-setting" */))
const _05726ef1 = () => interopDefault(import('../pages/operation-management-menu/notification-setting.vue' /* webpackChunkName: "pages/operation-management-menu/notification-setting" */))
const _9e6c1d3e = () => interopDefault(import('../pages/operation-management-menu/patrol-day-setting.vue' /* webpackChunkName: "pages/operation-management-menu/patrol-day-setting" */))
const _26ae2319 = () => interopDefault(import('../pages/operation-management-menu/reference-image-master.vue' /* webpackChunkName: "pages/operation-management-menu/reference-image-master" */))
const _5a43d73c = () => interopDefault(import('../pages/operation-management-menu/scheduled-return-date-slide.vue' /* webpackChunkName: "pages/operation-management-menu/scheduled-return-date-slide" */))
const _47a5e460 = () => interopDefault(import('../pages/operation-management-menu/separate-dictionary-setting.vue' /* webpackChunkName: "pages/operation-management-menu/separate-dictionary-setting" */))
const _86015c04 = () => interopDefault(import('../pages/operation-management-menu/setting-document-and-user-check.vue' /* webpackChunkName: "pages/operation-management-menu/setting-document-and-user-check" */))
const _257086fe = () => interopDefault(import('../pages/operation-management-menu/setting-lend-and-return-conditions.vue' /* webpackChunkName: "pages/operation-management-menu/setting-lend-and-return-conditions" */))
const _3f79d5ac = () => interopDefault(import('../pages/operation-management-menu/setting-reservation-condition.vue' /* webpackChunkName: "pages/operation-management-menu/setting-reservation-condition" */))
const _c8fcdc0a = () => interopDefault(import('../pages/operation-management-menu/shelf-type-conversion-info-setting.vue' /* webpackChunkName: "pages/operation-management-menu/shelf-type-conversion-info-setting" */))
const _458d7b4b = () => interopDefault(import('../pages/operation-management-menu/synonym-setting.vue' /* webpackChunkName: "pages/operation-management-menu/synonym-setting" */))
const _e8d54f26 = () => interopDefault(import('../pages/operation-management-menu/system-check.vue' /* webpackChunkName: "pages/operation-management-menu/system-check" */))
const _3a2ad9ad = () => interopDefault(import('../pages/operation-management-menu/system-config.vue' /* webpackChunkName: "pages/operation-management-menu/system-config" */))
const _5166c2f7 = () => interopDefault(import('../pages/operation-management-menu/trader-and-donor-setting.vue' /* webpackChunkName: "pages/operation-management-menu/trader-and-donor-setting" */))
const _b970da18 = () => interopDefault(import('../pages/order-list.vue' /* webpackChunkName: "pages/order-list" */))
const _c1e1db12 = () => interopDefault(import('../pages/order-list/index.vue' /* webpackChunkName: "pages/order-list/index" */))
const _6a878727 = () => interopDefault(import('../pages/order-list/create.vue' /* webpackChunkName: "pages/order-list/create" */))
const _515d469f = () => interopDefault(import('../pages/order-list/_id.vue' /* webpackChunkName: "pages/order-list/_id" */))
const _a302cd38 = () => interopDefault(import('../pages/reference.vue' /* webpackChunkName: "pages/reference" */))
const _a1b8f632 = () => interopDefault(import('../pages/reference/index.vue' /* webpackChunkName: "pages/reference/index" */))
const _43cb950f = () => interopDefault(import('../pages/reference/_id.vue' /* webpackChunkName: "pages/reference/_id" */))
const _8aca1e5c = () => interopDefault(import('../pages/reservation-cancel.vue' /* webpackChunkName: "pages/reservation-cancel" */))
const _9d911c00 = () => interopDefault(import('../pages/reservation-candidate-list.vue' /* webpackChunkName: "pages/reservation-candidate-list" */))
const _46267883 = () => interopDefault(import('../pages/reservation-candidate-list/index.vue' /* webpackChunkName: "pages/reservation-candidate-list/index" */))
const _16eebfab = () => interopDefault(import('../pages/reservation-candidate-list/_id.vue' /* webpackChunkName: "pages/reservation-candidate-list/_id" */))
const _08fefc10 = () => interopDefault(import('../pages/reservation-contact.vue' /* webpackChunkName: "pages/reservation-contact" */))
const _9b9ca30a = () => interopDefault(import('../pages/reservation-contact/index.vue' /* webpackChunkName: "pages/reservation-contact/index" */))
const _1481d8ba = () => interopDefault(import('../pages/reservation-contact/_id.vue' /* webpackChunkName: "pages/reservation-contact/_id" */))
const _2b5554e9 = () => interopDefault(import('../pages/reserve-preference-assign.vue' /* webpackChunkName: "pages/reserve-preference-assign" */))
const _5e4ecb32 = () => interopDefault(import('../pages/return.vue' /* webpackChunkName: "pages/return" */))
const _eca5f43e = () => interopDefault(import('../pages/sample.vue' /* webpackChunkName: "pages/sample" */))
const _358840b8 = () => interopDefault(import('../pages/sample/index.vue' /* webpackChunkName: "pages/sample/index" */))
const _f7f75be2 = () => interopDefault(import('../pages/sample/api-abort.vue' /* webpackChunkName: "pages/sample/api-abort" */))
const _17a2cc9e = () => interopDefault(import('../pages/sample/atom-input-text.vue' /* webpackChunkName: "pages/sample/atom-input-text" */))
const _6c103c62 = () => interopDefault(import('../pages/sample/atom-text-area.vue' /* webpackChunkName: "pages/sample/atom-text-area" */))
const _6de502b0 = () => interopDefault(import('../pages/sample/atom-text-field.vue' /* webpackChunkName: "pages/sample/atom-text-field" */))
const _f245a16e = () => interopDefault(import('../pages/sample/composition-api.vue' /* webpackChunkName: "pages/sample/composition-api" */))
const _bf133910 = () => interopDefault(import('../pages/sample/felica.vue' /* webpackChunkName: "pages/sample/felica" */))
const _77b270e2 = () => interopDefault(import('../pages/sample/form.vue' /* webpackChunkName: "pages/sample/form" */))
const _8ffb6ba4 = () => interopDefault(import('../pages/sample/logger.vue' /* webpackChunkName: "pages/sample/logger" */))
const _6fa8e51c = () => interopDefault(import('../pages/sample/modal-confirm.vue' /* webpackChunkName: "pages/sample/modal-confirm" */))
const _cbebb3ba = () => interopDefault(import('../pages/sample/mynumbercard.vue' /* webpackChunkName: "pages/sample/mynumbercard" */))
const _0eaf0438 = () => interopDefault(import('../pages/sample/pagination.vue' /* webpackChunkName: "pages/sample/pagination" */))
const _6e9574ee = () => interopDefault(import('../pages/sample/rewritecard.vue' /* webpackChunkName: "pages/sample/rewritecard" */))
const _be3fa570 = () => interopDefault(import('../pages/sample/sample.vue' /* webpackChunkName: "pages/sample/sample" */))
const _1c4c7c80 = () => interopDefault(import('../pages/sample/sample-data-table.vue' /* webpackChunkName: "pages/sample/sample-data-table" */))
const _7b3d251a = () => interopDefault(import('../pages/sample/sample2.vue' /* webpackChunkName: "pages/sample/sample2" */))
const _7b4b3c9b = () => interopDefault(import('../pages/sample/sample3.vue' /* webpackChunkName: "pages/sample/sample3" */))
const _c251d6c0 = () => interopDefault(import('../pages/sample/table.vue' /* webpackChunkName: "pages/sample/table" */))
const _171c11b0 = () => interopDefault(import('../pages/sample/test.vue' /* webpackChunkName: "pages/sample/test" */))
const _b2cdc056 = () => interopDefault(import('../pages/sample/tooltip.vue' /* webpackChunkName: "pages/sample/tooltip" */))
const _c5c755e8 = () => interopDefault(import('../pages/sample/user-registration-selection.vue' /* webpackChunkName: "pages/sample/user-registration-selection" */))
const _1d96a4d0 = () => interopDefault(import('../pages/sample/vuex.vue' /* webpackChunkName: "pages/sample/vuex" */))
const _02502319 = () => interopDefault(import('../pages/sample/websocket.vue' /* webpackChunkName: "pages/sample/websocket" */))
const _9c71377e = () => interopDefault(import('../pages/setting-default-value.vue' /* webpackChunkName: "pages/setting-default-value" */))
const _6dbf51b0 = () => interopDefault(import('../pages/shelf-type-temp-change.vue' /* webpackChunkName: "pages/shelf-type-temp-change" */))
const _2bc26278 = () => interopDefault(import('../pages/shelf-type-temp-change-fix.vue' /* webpackChunkName: "pages/shelf-type-temp-change-fix" */))
const _a1cd5a30 = () => interopDefault(import('../pages/simple-ordering.vue' /* webpackChunkName: "pages/simple-ordering" */))
const _1a483c89 = () => interopDefault(import('../pages/test.vue' /* webpackChunkName: "pages/test" */))
const _4ec09f42 = () => interopDefault(import('../pages/user.vue' /* webpackChunkName: "pages/user" */))
const _1695a776 = () => interopDefault(import('../pages/user/index.vue' /* webpackChunkName: "pages/user/index" */))
const _45bb7bed = () => interopDefault(import('../pages/user/_id.vue' /* webpackChunkName: "pages/user/_id" */))
const _4dff3c2a = () => interopDefault(import('../pages/sample-api/reference.vue' /* webpackChunkName: "pages/sample-api/reference" */))
const _47950feb = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/accept-collection",
    component: _50c2dd9c,
    name: "accept-collection"
  }, {
    path: "/accept-collection-actual",
    component: _4530798f,
    name: "accept-collection-actual"
  }, {
    path: "/accept-collection-magazine",
    component: _3a3edb56,
    name: "accept-collection-magazine"
  }, {
    path: "/accept-collection-simple",
    component: _1eb04fb3,
    name: "accept-collection-simple"
  }, {
    path: "/authority",
    component: _18fab548,
    children: [{
      path: "",
      component: _44bcb6df,
      name: "authority"
    }, {
      path: ":id",
      component: _0f78e507,
      name: "authority-id"
    }]
  }, {
    path: "/batch-menu",
    component: _b2dcee6e,
    name: "batch-menu",
    children: [{
      path: "bibliography-register",
      component: _3e92622a,
      name: "batch-menu-bibliography-register"
    }, {
      path: "collection-management",
      component: _2e1047e2,
      name: "batch-menu-collection-management"
    }, {
      path: "inventory",
      component: _3dc6ad19,
      name: "batch-menu-inventory"
    }, {
      path: "lend-return-reserve",
      component: _4b704c8c,
      name: "batch-menu-lend-return-reserve"
    }, {
      path: "mail-send",
      component: _32293f1b,
      name: "batch-menu-mail-send"
    }, {
      path: "order-accept",
      component: _7122cbe0,
      name: "batch-menu-order-accept"
    }, {
      path: "reminder",
      component: _a08dd5aa,
      name: "batch-menu-reminder"
    }, {
      path: "school-statistics",
      component: _acec1a4e,
      name: "batch-menu-school-statistics"
    }, {
      path: "selection-book",
      component: _3e698ac3,
      name: "batch-menu-selection-book"
    }, {
      path: "statistics",
      component: _c963e5c8,
      name: "batch-menu-statistics"
    }, {
      path: "user-management",
      component: _9f31a2fc,
      name: "batch-menu-user-management"
    }, {
      path: "bibliography-register/av-library-marc-register",
      component: _51d22378,
      name: "batch-menu-bibliography-register-av-library-marc-register"
    }, {
      path: "bibliography-register/bibliography-collection-export",
      component: _17ee0d4f,
      name: "batch-menu-bibliography-register-bibliography-collection-export"
    }, {
      path: "bibliography-register/bibliography-collection-import",
      component: _ebb9e680,
      name: "batch-menu-bibliography-register-bibliography-collection-import"
    }, {
      path: "bibliography-register/dc-ndl-register",
      component: _5e136cfe,
      name: "batch-menu-bibliography-register-dc-ndl-register"
    }, {
      path: "bibliography-register/nhk-marc-register",
      component: _213c0030,
      name: "batch-menu-bibliography-register-nhk-marc-register"
    }, {
      path: "bibliography-register/nrc-marc-catalog-register",
      component: _5c1e886c,
      name: "batch-menu-bibliography-register-nrc-marc-catalog-register"
    }, {
      path: "bibliography-register/nrc-marc-content-register",
      component: _65dd036a,
      name: "batch-menu-bibliography-register-nrc-marc-content-register"
    }, {
      path: "bibliography-register/order-marc-register",
      component: _9ced3876,
      name: "batch-menu-bibliography-register-order-marc-register"
    }, {
      path: "bibliography-register/oricon-marc-register",
      component: _12d83f1e,
      name: "batch-menu-bibliography-register-oricon-marc-register"
    }, {
      path: "bibliography-register/tohan-content-detail-register",
      component: _27a4d4d1,
      name: "batch-menu-bibliography-register-tohan-content-detail-register"
    }, {
      path: "bibliography-register/tohan-mark-register",
      component: _05dd16ae,
      name: "batch-menu-bibliography-register-tohan-mark-register"
    }, {
      path: "bibliography-register/trc-authority-register",
      component: _2785f668,
      name: "batch-menu-bibliography-register-trc-authority-register"
    }, {
      path: "bibliography-register/trc-authority-update",
      component: _3804c79c,
      name: "batch-menu-bibliography-register-trc-authority-update"
    }, {
      path: "bibliography-register/trc-books-and-av-register",
      component: _167182da,
      name: "batch-menu-bibliography-register-trc-books-and-av-register"
    }, {
      path: "bibliography-register/trc-books-and-av-update",
      component: _c0ecc88e,
      name: "batch-menu-bibliography-register-trc-books-and-av-update"
    }, {
      path: "bibliography-register/trc-content-detail-register",
      component: _610c55fc,
      name: "batch-menu-bibliography-register-trc-content-detail-register"
    }, {
      path: "bibliography-register/trc-content-detail-update",
      component: _f4610d3c,
      name: "batch-menu-bibliography-register-trc-content-detail-update"
    }, {
      path: "bibliography-register/trc-contents-data-register",
      component: _75c7c852,
      name: "batch-menu-bibliography-register-trc-contents-data-register"
    }, {
      path: "bibliography-register/trc-contents-data-update",
      component: _8b60ed90,
      name: "batch-menu-bibliography-register-trc-contents-data-update"
    }, {
      path: "bibliography-register/trc-new-book-automatic-order",
      component: _4ff345f4,
      name: "batch-menu-bibliography-register-trc-new-book-automatic-order"
    }, {
      path: "collection-management/another-facility-in-transit-collection-list",
      component: _4fd6e730,
      name: "batch-menu-collection-management-another-facility-in-transit-collection-list"
    }, {
      path: "collection-management/bibliography-and-collection-bulk-removal",
      component: _3ed59272,
      name: "batch-menu-collection-management-bibliography-and-collection-bulk-removal"
    }, {
      path: "collection-management/bibliography-bulk-removal",
      component: _7dee7479,
      name: "batch-menu-collection-management-bibliography-bulk-removal"
    }, {
      path: "collection-management/bibliography-collection-info-output",
      component: _69c89ece,
      name: "batch-menu-collection-management-bibliography-collection-info-output"
    }, {
      path: "collection-management/collection-bulk-removal",
      component: _1a136dfd,
      name: "batch-menu-collection-management-collection-bulk-removal"
    }, {
      path: "collection-management/invalid-collection-list",
      component: _4b61c414,
      name: "batch-menu-collection-management-invalid-collection-list"
    }, {
      path: "collection-management/list-by-collection-status",
      component: _1b28d297,
      name: "batch-menu-collection-management-list-by-collection-status"
    }, {
      path: "collection-management/removal-collection-list",
      component: _77845d89,
      name: "batch-menu-collection-management-removal-collection-list"
    }, {
      path: "collection-management/reserve-in-transit-collection-list",
      component: _78288ae2,
      name: "batch-menu-collection-management-reserve-in-transit-collection-list"
    }, {
      path: "collection-management/transfer-collection-list",
      component: _355f4044,
      name: "batch-menu-collection-management-transfer-collection-list"
    }, {
      path: "collection-management/unknown-collection-statistics",
      component: _60cbc42c,
      name: "batch-menu-collection-management-unknown-collection-statistics"
    }, {
      path: "inventory/list-inventory",
      component: _377f7d36,
      name: "batch-menu-inventory-list-inventory"
    }, {
      path: "lend-return-reserve/borrowed-collection-list",
      component: _0808fb3c,
      name: "batch-menu-lend-return-reserve-borrowed-collection-list"
    }, {
      path: "lend-return-reserve/collection-list-by-lend-books-count",
      component: _6232e0e8,
      name: "batch-menu-lend-return-reserve-collection-list-by-lend-books-count"
    }, {
      path: "lend-return-reserve/forced-return",
      component: _168ac68c,
      name: "batch-menu-lend-return-reserve-forced-return"
    }, {
      path: "lend-return-reserve/lend-collection-list",
      component: _20258b57,
      name: "batch-menu-lend-return-reserve-lend-collection-list"
    }, {
      path: "lend-return-reserve/lend-db-update",
      component: _af972c3c,
      name: "batch-menu-lend-return-reserve-lend-db-update"
    }, {
      path: "lend-return-reserve/lend-info-extraction",
      component: _2409c260,
      name: "batch-menu-lend-return-reserve-lend-info-extraction"
    }, {
      path: "lend-return-reserve/on-shelf-reserve-list",
      component: _d1ef8330,
      name: "batch-menu-lend-return-reserve-on-shelf-reserve-list"
    }, {
      path: "lend-return-reserve/reserve-cancel-list",
      component: _3418bb30,
      name: "batch-menu-lend-return-reserve-reserve-cancel-list"
    }, {
      path: "lend-return-reserve/reserve-collection-list",
      component: _40d85978,
      name: "batch-menu-lend-return-reserve-reserve-collection-list"
    }, {
      path: "lend-return-reserve/reserve-contact-mail",
      component: _59c24f7d,
      name: "batch-menu-lend-return-reserve-reserve-contact-mail"
    }, {
      path: "lend-return-reserve/reserve-contact-postcard-date",
      component: _59ba4c56,
      name: "batch-menu-lend-return-reserve-reserve-contact-postcard-date"
    }, {
      path: "lend-return-reserve/reserve-contact-postcard-user",
      component: _58657f72,
      name: "batch-menu-lend-return-reserve-reserve-contact-postcard-user"
    }, {
      path: "lend-return-reserve/reserve-return-waiting-collection-forwarding-candidate-list",
      component: _604562dd,
      name: "batch-menu-lend-return-reserve-reserve-return-waiting-collection-forwarding-candidate-list"
    }, {
      path: "lend-return-reserve/reserve-return-waiting-collection-list",
      component: _36cb4949,
      name: "batch-menu-lend-return-reserve-reserve-return-waiting-collection-list"
    }, {
      path: "lend-return-reserve/reserve-standing-collection-list",
      component: _29cdf5a5,
      name: "batch-menu-lend-return-reserve-reserve-standing-collection-list"
    }, {
      path: "lend-return-reserve/reserve-user-list",
      component: _9f4d5812,
      name: "batch-menu-lend-return-reserve-reserve-user-list"
    }, {
      path: "lend-return-reserve/return-db-update",
      component: _1eef1463,
      name: "batch-menu-lend-return-reserve-return-db-update"
    }, {
      path: "lend-return-reserve/return-info-extraction",
      component: _7c922491,
      name: "batch-menu-lend-return-reserve-return-info-extraction"
    }, {
      path: "mail-send/mail-send",
      component: _5bdfd5a7,
      name: "batch-menu-mail-send-mail-send"
    }, {
      path: "order-accept/accept-ledger",
      component: _6ed1ce48,
      name: "batch-menu-order-accept-accept-ledger"
    }, {
      path: "order-accept/delivery-and-situation-list",
      component: _2f088c6c,
      name: "batch-menu-order-accept-delivery-and-situation-list"
    }, {
      path: "order-accept/long-over-due-collection-purchase-candidate-list",
      component: _c34d9230,
      name: "batch-menu-order-accept-long-over-due-collection-purchase-candidate-list"
    }, {
      path: "order-accept/missing-number-collection-list",
      component: _5b5843dc,
      name: "batch-menu-order-accept-missing-number-collection-list"
    }, {
      path: "order-accept/new-breaking-news",
      component: _ebdafd04,
      name: "batch-menu-order-accept-new-breaking-news"
    }, {
      path: "order-accept/order-list",
      component: _262a081f,
      name: "batch-menu-order-accept-order-list"
    }, {
      path: "order-accept/selection-candidate-list",
      component: _336b35eb,
      name: "batch-menu-order-accept-selection-candidate-list"
    }, {
      path: "order-accept/tohan-books-order-data-create",
      component: _f472aad0,
      name: "batch-menu-order-accept-tohan-books-order-data-create"
    }, {
      path: "order-accept/trc-accept-marc-register",
      component: _15be2230,
      name: "batch-menu-order-accept-trc-accept-marc-register"
    }, {
      path: "order-accept/trc-books-order-data-create",
      component: _643b2503,
      name: "batch-menu-order-accept-trc-books-order-data-create"
    }, {
      path: "order-accept/undelivered-and-situation-list",
      component: _dab20fb2,
      name: "batch-menu-order-accept-undelivered-and-situation-list"
    }, {
      path: "reminder/reminder-letter",
      component: _7d1dd97a,
      name: "batch-menu-reminder-reminder-letter"
    }, {
      path: "reminder/reminder-list",
      component: _72d2a8f2,
      name: "batch-menu-reminder-reminder-list"
    }, {
      path: "reminder/reminder-mail",
      component: _2200c98b,
      name: "batch-menu-reminder-reminder-mail"
    }, {
      path: "reminder/reminder-postcard",
      component: _6f4db5f8,
      name: "batch-menu-reminder-reminder-postcard"
    }, {
      path: "school-statistics/advancement",
      component: _e8831eb2,
      name: "batch-menu-school-statistics-advancement"
    }, {
      path: "school-statistics/best-reader",
      component: _25241ada,
      name: "batch-menu-school-statistics-best-reader"
    }, {
      path: "school-statistics/lend",
      component: _616129b8,
      name: "batch-menu-school-statistics-lend"
    }, {
      path: "school-statistics/lend-collection-list",
      component: _33f83058,
      name: "batch-menu-school-statistics-lend-collection-list"
    }, {
      path: "school-statistics/new-student-registration",
      component: _53138ee1,
      name: "batch-menu-school-statistics-new-student-registration"
    }, {
      path: "school-statistics/user-list",
      component: _72ba90e7,
      name: "batch-menu-school-statistics-user-list"
    }, {
      path: "selection-book/selection-book-and-bibliography-list",
      component: _5f8701cf,
      name: "batch-menu-selection-book-selection-book-and-bibliography-list"
    }, {
      path: "selection-book/selection-book-and-order-list",
      component: _0cca4c07,
      name: "batch-menu-selection-book-selection-book-and-order-list"
    }, {
      path: "selection-book/selection-book-and-order-situation",
      component: _fa769f36,
      name: "batch-menu-selection-book-selection-book-and-order-situation"
    }, {
      path: "statistics/best-reader",
      component: _930fe2d4,
      name: "batch-menu-statistics-best-reader"
    }, {
      path: "statistics/collection-and-removal-statistics",
      component: _1164e99a,
      name: "batch-menu-statistics-collection-and-removal-statistics"
    }, {
      path: "statistics/daily-statistics-output",
      component: _168cc0fe,
      name: "batch-menu-statistics-daily-statistics-output"
    }, {
      path: "statistics/lend",
      component: _2f5f3b15,
      name: "batch-menu-statistics-lend"
    }, {
      path: "statistics/monthly-statistics-output",
      component: _71284416,
      name: "batch-menu-statistics-monthly-statistics-output"
    }, {
      path: "statistics/pack-lend-statistics",
      component: _5ee57033,
      name: "batch-menu-statistics-pack-lend-statistics"
    }, {
      path: "statistics/public-library-questionnaire-statistics",
      component: _7163fa8d,
      name: "batch-menu-statistics-public-library-questionnaire-statistics"
    }, {
      path: "statistics/reference-and-copy-and-entertainment-statistics",
      component: _4b363768,
      name: "batch-menu-statistics-reference-and-copy-and-entertainment-statistics"
    }, {
      path: "statistics/registrant-statistics",
      component: _041f0b62,
      name: "batch-menu-statistics-registrant-statistics"
    }, {
      path: "statistics/reserve-best",
      component: _93976d0a,
      name: "batch-menu-statistics-reserve-best"
    }, {
      path: "statistics/reserve-statistics",
      component: _6ad4b1fa,
      name: "batch-menu-statistics-reserve-statistics"
    }, {
      path: "statistics/return-statistics",
      component: _043017ac,
      name: "batch-menu-statistics-return-statistics"
    }, {
      path: "statistics/select-shelf-lend-statistics",
      component: _23bbcb9a,
      name: "batch-menu-statistics-select-shelf-lend-statistics"
    }, {
      path: "statistics/yearly-statistics-output",
      component: _7e31630e,
      name: "batch-menu-statistics-yearly-statistics-output"
    }, {
      path: "user-management/basic-residents-data-register",
      component: _711a0466,
      name: "batch-menu-user-management-basic-residents-data-register"
    }, {
      path: "user-management/data-shortage-user-list",
      component: _1cc3eb6e,
      name: "batch-menu-user-management-data-shortage-user-list"
    }, {
      path: "user-management/expired-user-list",
      component: _f3192930,
      name: "batch-menu-user-management-expired-user-list"
    }, {
      path: "user-management/user-data-register",
      component: _74591a64,
      name: "batch-menu-user-management-user-data-register"
    }, {
      path: "user-management/user-list",
      component: _0bcfd010,
      name: "batch-menu-user-management-user-list"
    }, {
      path: "user-management/user-removal",
      component: _73f0426a,
      name: "batch-menu-user-management-user-removal"
    }]
  }, {
    path: "/bibliographies",
    component: _fb692c92,
    children: [{
      path: "",
      component: _9e8cea0c,
      name: "bibliographies"
    }, {
      path: "detail-real",
      component: _0a42007c,
      name: "bibliographies-detail-real"
    }, {
      path: "detail-set",
      component: _18c80c24,
      name: "bibliographies-detail-set"
    }, {
      path: "index.type",
      component: _1f0fddb2,
      name: "bibliographies-index.type"
    }, {
      path: "search-result",
      component: _a9af2bec,
      name: "bibliographies-search-result"
    }, {
      path: "search-result-authority",
      component: _28673b80,
      name: "bibliographies-search-result-authority"
    }, {
      path: "search-result-content",
      component: _3edb39b6,
      name: "bibliographies-search-result-content"
    }]
  }, {
    path: "/bibliography-collection-bulk-edit",
    component: _d6f8e1cc,
    name: "bibliography-collection-bulk-edit"
  }, {
    path: "/borrowing-history",
    component: _057f552d,
    name: "borrowing-history"
  }, {
    path: "/collection-browse-inside",
    component: _0fd38b27,
    name: "collection-browse-inside"
  }, {
    path: "/collection-list",
    component: _4f8f0ac6,
    children: [{
      path: "",
      component: _247de4c9,
      name: "collection-list"
    }, {
      path: ":id",
      component: _1aa08571,
      name: "collection-list-id"
    }]
  }, {
    path: "/forward-request-answer",
    component: _670275fb,
    name: "forward-request-answer"
  }, {
    path: "/forward-request-status",
    component: _3c9acc2f,
    name: "forward-request-status"
  }, {
    path: "/ic-tag-encode",
    component: _63d9b956,
    name: "ic-tag-encode"
  }, {
    path: "/inspection",
    component: _e4497daa,
    children: [{
      path: "",
      component: _2dc20924,
      name: "inspection"
    }, {
      path: "input-offline/:id?",
      component: _5a0a6627,
      name: "inspection-input-offline-id"
    }, {
      path: "input/:id?",
      component: _fb94cdde,
      name: "inspection-input-id"
    }, {
      path: "output/:id?",
      component: _3679a5c0,
      name: "inspection-output-id"
    }]
  }, {
    path: "/inspection-bulk-update",
    component: _3abc767c,
    name: "inspection-bulk-update"
  }, {
    path: "/jobs",
    component: _012b5b66,
    name: "jobs"
  }, {
    path: "/lend",
    component: _5c55bb34,
    name: "lend"
  }, {
    path: "/lend-history",
    component: _c3d5fea6,
    name: "lend-history"
  }, {
    path: "/login",
    component: _113cb302,
    name: "login"
  }, {
    path: "/operation-management-menu",
    component: _4241945c,
    children: [{
      path: "",
      component: _03673442,
      name: "operation-management-menu"
    }, {
      path: "budget-management",
      component: _e2ec0e50,
      name: "operation-management-menu-budget-management"
    }, {
      path: "closing-day-setting",
      component: _fbe1ec58,
      name: "operation-management-menu-closing-day-setting"
    }, {
      path: "code-setting",
      component: _d3ed881a,
      name: "operation-management-menu-code-setting"
    }, {
      path: "delete-by-series",
      component: _45ed5ce4,
      name: "operation-management-menu-delete-by-series"
    }, {
      path: "lend-books-count-confirmation",
      component: _ed1a4f3e,
      name: "operation-management-menu-lend-books-count-confirmation"
    }, {
      path: "login-user-management",
      component: _1ab72cae,
      name: "operation-management-menu-login-user-management"
    }, {
      path: "new-arrival-magazine-mail-setting",
      component: _48e4c31f,
      name: "operation-management-menu-new-arrival-magazine-mail-setting"
    }, {
      path: "notification-setting",
      component: _05726ef1,
      name: "operation-management-menu-notification-setting"
    }, {
      path: "patrol-day-setting",
      component: _9e6c1d3e,
      name: "operation-management-menu-patrol-day-setting"
    }, {
      path: "reference-image-master",
      component: _26ae2319,
      name: "operation-management-menu-reference-image-master"
    }, {
      path: "scheduled-return-date-slide",
      component: _5a43d73c,
      name: "operation-management-menu-scheduled-return-date-slide"
    }, {
      path: "separate-dictionary-setting",
      component: _47a5e460,
      name: "operation-management-menu-separate-dictionary-setting"
    }, {
      path: "setting-document-and-user-check",
      component: _86015c04,
      name: "operation-management-menu-setting-document-and-user-check"
    }, {
      path: "setting-lend-and-return-conditions",
      component: _257086fe,
      name: "operation-management-menu-setting-lend-and-return-conditions"
    }, {
      path: "setting-reservation-condition",
      component: _3f79d5ac,
      name: "operation-management-menu-setting-reservation-condition"
    }, {
      path: "shelf-type-conversion-info-setting",
      component: _c8fcdc0a,
      name: "operation-management-menu-shelf-type-conversion-info-setting"
    }, {
      path: "synonym-setting",
      component: _458d7b4b,
      name: "operation-management-menu-synonym-setting"
    }, {
      path: "system-check",
      component: _e8d54f26,
      name: "operation-management-menu-system-check"
    }, {
      path: "system-config",
      component: _3a2ad9ad,
      name: "operation-management-menu-system-config"
    }, {
      path: "trader-and-donor-setting",
      component: _5166c2f7,
      name: "operation-management-menu-trader-and-donor-setting"
    }]
  }, {
    path: "/order-list",
    component: _b970da18,
    children: [{
      path: "",
      component: _c1e1db12,
      name: "order-list"
    }, {
      path: "create",
      component: _6a878727,
      name: "order-list-create"
    }, {
      path: ":id",
      component: _515d469f,
      name: "order-list-id"
    }]
  }, {
    path: "/reference",
    component: _a302cd38,
    children: [{
      path: "",
      component: _a1b8f632,
      name: "reference"
    }, {
      path: ":id",
      component: _43cb950f,
      name: "reference-id"
    }]
  }, {
    path: "/reservation-cancel",
    component: _8aca1e5c,
    name: "reservation-cancel"
  }, {
    path: "/reservation-candidate-list",
    component: _9d911c00,
    children: [{
      path: "",
      component: _46267883,
      name: "reservation-candidate-list"
    }, {
      path: ":id",
      component: _16eebfab,
      name: "reservation-candidate-list-id"
    }]
  }, {
    path: "/reservation-contact",
    component: _08fefc10,
    children: [{
      path: "",
      component: _9b9ca30a,
      name: "reservation-contact"
    }, {
      path: ":id",
      component: _1481d8ba,
      name: "reservation-contact-id"
    }]
  }, {
    path: "/reserve-preference-assign",
    component: _2b5554e9,
    name: "reserve-preference-assign"
  }, {
    path: "/return",
    component: _5e4ecb32,
    name: "return"
  }, {
    path: "/sample",
    component: _eca5f43e,
    children: [{
      path: "",
      component: _358840b8,
      name: "sample"
    }, {
      path: "api-abort",
      component: _f7f75be2,
      name: "sample-api-abort"
    }, {
      path: "atom-input-text",
      component: _17a2cc9e,
      name: "sample-atom-input-text"
    }, {
      path: "atom-text-area",
      component: _6c103c62,
      name: "sample-atom-text-area"
    }, {
      path: "atom-text-field",
      component: _6de502b0,
      name: "sample-atom-text-field"
    }, {
      path: "composition-api",
      component: _f245a16e,
      name: "sample-composition-api"
    }, {
      path: "felica",
      component: _bf133910,
      name: "sample-felica"
    }, {
      path: "form",
      component: _77b270e2,
      name: "sample-form"
    }, {
      path: "logger",
      component: _8ffb6ba4,
      name: "sample-logger"
    }, {
      path: "modal-confirm",
      component: _6fa8e51c,
      name: "sample-modal-confirm"
    }, {
      path: "mynumbercard",
      component: _cbebb3ba,
      name: "sample-mynumbercard"
    }, {
      path: "pagination",
      component: _0eaf0438,
      name: "sample-pagination"
    }, {
      path: "rewritecard",
      component: _6e9574ee,
      name: "sample-rewritecard"
    }, {
      path: "sample",
      component: _be3fa570,
      name: "sample-sample"
    }, {
      path: "sample-data-table",
      component: _1c4c7c80,
      name: "sample-sample-data-table"
    }, {
      path: "sample2",
      component: _7b3d251a,
      name: "sample-sample2"
    }, {
      path: "sample3",
      component: _7b4b3c9b,
      name: "sample-sample3"
    }, {
      path: "table",
      component: _c251d6c0,
      name: "sample-table"
    }, {
      path: "test",
      component: _171c11b0,
      name: "sample-test"
    }, {
      path: "tooltip",
      component: _b2cdc056,
      name: "sample-tooltip"
    }, {
      path: "user-registration-selection",
      component: _c5c755e8,
      name: "sample-user-registration-selection"
    }, {
      path: "vuex",
      component: _1d96a4d0,
      name: "sample-vuex"
    }, {
      path: "websocket",
      component: _02502319,
      name: "sample-websocket"
    }]
  }, {
    path: "/setting-default-value",
    component: _9c71377e,
    name: "setting-default-value"
  }, {
    path: "/shelf-type-temp-change",
    component: _6dbf51b0,
    name: "shelf-type-temp-change"
  }, {
    path: "/shelf-type-temp-change-fix",
    component: _2bc26278,
    name: "shelf-type-temp-change-fix"
  }, {
    path: "/simple-ordering",
    component: _a1cd5a30,
    name: "simple-ordering"
  }, {
    path: "/test",
    component: _1a483c89,
    name: "test"
  }, {
    path: "/user",
    component: _4ec09f42,
    children: [{
      path: "",
      component: _1695a776,
      name: "user"
    }, {
      path: ":id",
      component: _45bb7bed,
      name: "user-id"
    }]
  }, {
    path: "/sample-api/reference",
    component: _4dff3c2a,
    name: "sample-api-reference"
  }, {
    path: "/",
    component: _47950feb,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
